"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputTypeByDevice = void 0;
var _browser = require("./browser.utils");
// TODO: remove this once Safari 16 fixes their bug with decimal point on number inputs
// TODO: because price input should always be number and not tel
var getInputTypeByDevice = exports.getInputTypeByDevice = function getInputTypeByDevice() {
  var safariVersion = (0, _browser.getSafariVersion)();
  if (safariVersion && getMajorVersion(safariVersion) >= 16) {
    return 'tel';
  }
  return 'number';
};
var getMajorVersion = function getMajorVersion(version) {
  return Number(version.split('.')[0]);
};
//# sourceMappingURL=input.utils.js.map